import { Suspense } from "react";
import LoadingOverlay from "../components/loaders/LoadingOverlay";

const SuspenseLayout = ({ children }) => {
  return (
    <Suspense fallback={<LoadingOverlay isLoading={true} />}>
      {children}
    </Suspense>
  );
};

export default SuspenseLayout;
